<template>
  <ul v-if="hasCounters" class="notifications-container">
    <NotificationCounter variant="primary" :value="emergencyCounter" />
    <NotificationCounter variant="secondary" :value="counters.unreadMessages" />
    <NotificationCounter
      v-if="showPrivateUnreadMessages"
      variant="tertiary"
      :value="privateUnreadMessagesCounter"
    />
  </ul>
</template>

<script>
import NotificationCounter from '@/components/app/atoms/NotificationCounter.vue'

export default {
  components: { NotificationCounter },
  props: {
    counters: { type: Object, default: undefined },
    showMentions: Boolean,
    isTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasCounters() {
      return (
        this.counters?.emergency ||
        this.counters?.unreadMessages ||
        this.counters?.privateUnreadMessages ||
        this.counters?.privateUnreadMentions
      )
    },
    emergencyCounter() {
      return this.getCounterFormatted(this.counters?.emergency)
    },
    unreadMessagesCounter() {
      return this.getCounterFormatted(this.counters?.unreadMessages)
    },
    privateUnreadMessagesCounter() {
      let privateUnreadMessages = null
      let privateUnreadMentions = null
      if (this.showUnreadMessages) {
        privateUnreadMessages = this.counters?.privateUnreadMessages
      }
      if (this.showMentions) {
        privateUnreadMentions = this.counters?.privateUnreadMentions
      }
      return this.getCounterFormatted(
        privateUnreadMessages,
        privateUnreadMentions
      )
    },
    showUnreadMessages() {
      return (
        this.counters?.privateUnreadMessages !==
        this.counters?.privateUnreadMentions
      )
    },
    showPrivateUnreadMessages() {
      return !this.counters?.emergency || !this.counters?.unreadMessages
    }
  },
  methods: {
    getCounterFormatted(counter, mentionsCounter) {
      if (counter > 99) return '99+'

      if (mentionsCounter) {
        return [counter, `${mentionsCounter}@`].filter(Boolean).join(' + ')
      }

      return counter
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-container {
  list-style: none;
  white-space: nowrap;
  padding: 0;
}
</style>
